import { Component, OnInit, Input, Output, EventEmitter, HostListener, ViewEncapsulation } from "@angular/core";
import { AuthenticationService } from "../services/authentication.service";
import { AssetDetailService } from "../services/asset-detail.service";
import { AssetAttributesService } from "../services/asset-attributes.service";
import { EsriMapComponent } from "../esri-map/esri-map.component";
import { Globals } from "../shared/globals";
import { environment } from "src/environments/environment";
import { GenericLayerService } from "../services/generic-layer.service";
import { GenericMapMethodsService } from "../services/generic-map-methods.service";
import { TranslateService, TranslateModule } from "@ngx-translate/core";
import { EventEmittersService } from "../services/event-emitters.service";
import { UserService } from "src/app/services/user.service";
import { AutoUnsubscribe } from "ngx-auto-unsubscribe";
import { Subscription } from "rxjs";
import { GridApi } from "ag-grid-community";
import Swal from "sweetalert2";
import pdfMake from "pdfmake/build/pdfmake";
import { CustomTranslatePipe } from "../shared/custom-translate.pipe";
import { MatDatepickerModule } from "@angular/material/datepicker";
import { MatButtonModule } from "@angular/material/button";
import { FormsModule } from "@angular/forms";
import { MatInputModule } from "@angular/material/input";
import { MatFormFieldModule } from "@angular/material/form-field";
import { DropdownComponent } from "../shared/dropdown/dropdown.component";
import { AgGridAngular } from "ag-grid-angular";
import { MatTabsModule } from "@angular/material/tabs";
import { ConfigurableHeaderComponent } from "../shared/configurable-header/configurable-header.component";
import { JsonPipe, NgFor, NgIf } from "@angular/common";
import { IUser } from "../interface/user";
import { IDropdownListItem } from "../interface/DropDownListItem";

@AutoUnsubscribe()
@Component({
    selector: "sms-make-viewer",
    templateUrl: "./make-viewer.component.html",
    styleUrls: ["./make-viewer.component.scss"],
    host: { class: "makeViewerDiv" },
    encapsulation: ViewEncapsulation.None,
    standalone: true,
    imports: [NgIf, NgFor, ConfigurableHeaderComponent, MatTabsModule, AgGridAngular, DropdownComponent, MatFormFieldModule, MatInputModule, FormsModule, MatButtonModule, MatDatepickerModule, TranslateModule, CustomTranslatePipe, JsonPipe]
})
export class MakeViewerComponent implements OnInit {
  /** Variables */
  @Input() Query: any;
  @Input() Graphic: any;
  @Input() QueryTask: any;
  @Input() map: any;
  @Input() tasksCategory: any;
  @Input() FeatureLayer: any;
  @Input() all: any;
  @Input() Color: any;
  @Input() PictureMarkerSymbol: any;
  @Input() JoinDataSource: any;
  @Input() RelationshipQuery: any;
  @Input() Point: any;

  @Output() closeTable = new EventEmitter();
  @Output() showTask = new EventEmitter();
  @Output() rowDataObjVar = new EventEmitter();

  private currentUser: IUser  ;
  loading = false;
  changeWhileLoading_tabEvent = null;
  changeWhileLoading_assignedToEvent = null;
  activityLyrDomains;
  rowSelection = 'multiple'; //{ mode: 'multiple'};
  gridApiOrders: GridApi;
  gridApiTracking: GridApi;
  gridApiHistory: GridApi;
  gridApiActive: GridApi;
  showForms = true;
  showUpdateForm = true;
  showDatesForm = false;
  showGridManagementForm = false;
  assignedToMeChecked = false;
  taskGraphicsLyr;
  maintenanceLyr;
  rowDataOrders = [];
  rowDataTracking = [];
  rowDataHistory = [];
  activeTab;
  fabUpdateButtonLabel;
  gridSelCountAdded=[];             // track which tabs have had selected count span added to keep from adding multiple
  previousSelectedRows=[];          // for multi-select management - to determine if row was added or removed from selection
  lastUpdate = '';                  // detect lack of change in update form to prevent multiple submits
  startDate: Date = new Date();
  endDate: Date = new Date();
  clientUsersList: IDropdownListItem[] = [];                  //for Assigned To
  fabWorker;
  fabLocation;
  fabComment;
  LocationList: IDropdownListItem[] = [{value: "Cart", display: "Cart"}, {value: "Warehouse", display: "Warehouse"}, {value:"Truck", display: "Truck"}];  // replaced if domain is defined
  madeCheckbox = true;
  showMadeCheckbox = true;
  signLyrId;
  allColumns: any[] = [];

  //#region Grid Definitions

  // Column Defs for each tab
  columnDefsOrders = [
    { headerName: this.translateService.instant("Mytasks.header.AssetID"), field: "AssetID", colId: "AssetID" },
    { headerName: this.translateService.instant("Mytasks.header.AssetCode"), field: "AssetCode", colId: "AssetCode" },
    { headerName: this.translateService.instant("Mytasks.header.Activity"), field: "Activity", colId: "Activity" },
    { headerName: "Maint Comment", field: "Comment", colId: "MaintComment" },
    { headerName: "Construction", minWidth: 150, valueGetter: this.vgConstruction, colId: "Construction"},
    { headerName: "Support", valueGetter: this.vgSupport, colId: "Support"}, //field: "ParentAssetCode"},
    { headerName: "Route", valueGetter: this.vgLocation, colId: "Route" },
    { headerName: "Order", valueGetter: this.vgDateName, colId: "Order" },
    { headerName: "Fab Comment", field: "FabComment", colId: "FabComment" },
    { headerName: "Assigned To", field: "Worker", colId: "AssignedTo" },
    { headerName: '', maxWidth: 50, checkboxSelection: true, headerCheckboxSelectionFilteredOnly: true, 
                  headerCheckboxSelection: true, sortable: false, resizable: true, filter: false, 
                  pinned: "right", lockPinned: true, colId: "Select"}
  ];

  columnDefsTracking = [
    { headerName: this.translateService.instant("Mytasks.header.AssetID"), field: "AssetID", colId: "AssetID" },
    { headerName: this.translateService.instant("Mytasks.header.AssetCode"), field: "AssetCode", colId: "AssetCode" },
    { headerName: this.translateService.instant("Mytasks.header.Activity"), field: "Activity", colId: "Activity" },
    { headerName: "Construction", minWidth: 140, valueGetter: this.vgConstruction, colId: "Construction"},
    { headerName: "Support", valueGetter: this.vgSupport, colId: "Support"},
    { headerName: "Route", valueGetter: this.vgLocation, colId: "Route" },
    { headerName: "Order", valueGetter: this.vgDateName, colId: "Order"},
    { headerName: "Fabricated", valueGetter: this.vgDateName, colId: "Fabricated"},
    { headerName: "Fab Comment", field: "FabComment", colId: "FabComment" },
    { headerName: "Location", field: "FabLocation", colId: "Location" },
    { headerName: "Assigned To", field: "Worker", colId: "AssignedTo" },
    { headerName: '', maxWidth: 50, checkboxSelection: true, headerCheckboxSelectionFilteredOnly: true, 
                  headerCheckboxSelection: true, sortable: true, resizable: true, filter: false, 
                  pinned: "right", lockPinned: true, colId: "Select"}
  ];

  columnDefsHistory = [
    { headerName: this.translateService.instant("Mytasks.header.AssetID"), field: "AssetID", colId: "AssetID" },
    { headerName: this.translateService.instant("Mytasks.header.AssetCode"), field: "AssetCode", colId: "AssetCode" },
    { headerName: "Asset Status", valueGetter: this.vgAssetStatus, colId: "Asset Status"},
    { headerName: this.translateService.instant("Mytasks.header.Activity"), field: "Activity", colId: "Activity" },
    { headerName: "Status", field: "Status", colId: "Status" },
    { headerName: "Order", valueGetter: this.vgDateName, colId: "Order"},
    { headerName: "Fabricated", valueGetter: this.vgDateName, colId: "Fabricated"},
    { headerName: "Installed", valueGetter: this.vgDateName, colId: "Installed"}
  ];

  // #region Value Getters
  vgAssetStatus(params){
    let val="";
    if (params.data.ReplacedBy){ val = "replaced by " + params.data.ReplacedBy;}
    else {val = params.data.AssetStatus;}
    return val;
  }

  vgSupport(params){
    let val="";
    if (params.data.ParentID){ val += params.data.ParentID;}
    if (params.data.ParentAssetCode){ 
      let id = params.data.ParentAssetCode;
      val += " ";
      val += id.substring(0,4) == "SUP-" ? id.substring(4): id;
    }
    return val;
  }

  vgLocation(params){
    let val="(";
    if (params.data.Region2){ val += params.data.Region2;}
    if (params.data.Region3){ val += "_" + params.data.Region3;}
    if (params.data.Region4){ val += "_" + params.data.Region4;}
    val += ") ";
    val += params.data.Route;
    return val;
  }

  vgDateName(params){
    let d = params.data;
    let val="";
    function yearFirstDate(date){
      let dt = new Date(date);
      return dt.getFullYear() + "/" + String(dt.getMonth() + 1).padStart(2, '0') + "/" + String(dt.getDate()).padStart(2, '0') + " ";
    }  
    switch (params.colDef.headerName){
      case "Order":
        if (d.CreationDate) {val += yearFirstDate(d.CreationDate);}
        if (d.CreatedBy) {val += d.CreatedBy;}
        break;
      case "Fabricated":
        if (d.FabDate) {val += yearFirstDate(d.FabDate);}
        if (d.FabBy) {val += d.FabBy;}
        break;
      case "Installed":
        if (d.CompletionDate) {val += yearFirstDate(d.CompletionDate);}
        if (d.CompletedBy) {val += d.CompletedBy;}
        break;
    }
    return val;
  }

  vgConstruction(params){
    let val = '';
    let d = params.data;
    let width = d.DimWidth ? d.DimWidth : '';
    let height = d.DimHeight ? d.DimHeight : '';
    let sheet = d.SheetType ? d.SheetType : '';
    let sheet2 = d.SheetType2 ? d.SheetType2 : '';
    let sheetColor = d.SheetColor ? d.SheetColor : '';
    let sheetColor2 = d.SheetColor2 ? d.SheetColor2 : '';
    let inkColor = d.InkColor ? d.InkColor : '';
    let inkColor2 = d.InkColor2 ? d.InkColor2 : '';
    let legend = d.Legend ? "'" + d.Legend + "'" : '';
    if (width || height) { val += width + "x" + height}
    if (sheet && sheet2){
      val+= " " + sheet + "/" + sheet2;
    } else {
      val += (" " + sheet).trimEnd() + (" " + sheet2).trimEnd()
    }
    if (sheetColor && sheetColor2){
      val+= " " + sheetColor + "/" + sheetColor2;
    } else {
      val += (" " + sheetColor).trimEnd() + (" " + sheetColor2).trimEnd()
    }
    if (inkColor && inkColor2){
      val+= " " + inkColor + "/" + inkColor2;
    } else {
      val += (" " + inkColor).trimEnd() + (" " + inkColor2).trimEnd()
    }
    val += (" " + legend).trimEnd();
    return val;
  }
  // #endregion Value Getters

  defaultColDef = {
      editable: false,
      sortable: true,
      flex: 1,
      minWidth: 75,
      filter: true,
      resizable: true
  };

  pagination = true;
  pagPageSize =  100;
  gridOptions = {
    getRowId: (params) => params.data.MaintID,
    suppressDragLeaveHidesColumns: true
  };

  ordersHidden = true;
  ordersReadOnly = true;
  trackingHidden = true;
  trackingReadOnly = true;
  historyHidden = true;
  readOnly = true;
  tabs =[]; //track order of enabled tabs
  tabIndex = 0;

  subsUserRoles: Subscription;
  subsTasksModified: Subscription;
  subsEmitOpenDetailedMaintenance: Subscription;
  subsEmitClosedDetailedMaintenance: Subscription;
  getAllFeaturesSubscribe: Subscription;
  getFilteredFeaturesByFieldSubscribe: Subscription;

  //#endregion   grid definitions

  //Added for ADA
  @HostListener("document:keydown.enter", ["$event"])
  onKeydownHandler(event: KeyboardEvent) {
    if (event.target["type"] === "checkbox" && event.target["id"] === "assigntome") {
      if ((<HTMLInputElement>event.target).checked) {
        (<HTMLInputElement>event.target).checked = false;
      } else {
        (<HTMLInputElement>event.target).checked = true;
      }
      this.assignedToChanged(event);
    }
  }
 
  constructor(
    private authenticationService: AuthenticationService,
    private assetAttributesService: AssetAttributesService,
    public esritools: EsriMapComponent,
    public objGlobals: Globals,
    private genericLayerService: GenericLayerService,
    private assetDetailService: AssetDetailService,
    public genericMapMethodsService: GenericMapMethodsService,
    private translateService: TranslateService,
    public eeService: EventEmittersService,
    private userService: UserService
  ) {
    // Visibility / Read Only setup per user role
    let rp = this.authenticationService.currentUserValue.rolePermissions;    
    this.ordersHidden = rp.fabOrders == 0;
    this.ordersReadOnly = rp.fabOrders == 1;    // possible values 0=no, 1=read only, 2=edit
    this.trackingHidden = rp.fabTracking == 0;
    this.trackingReadOnly = rp.fabTracking == 1;
    this.historyHidden = rp.fabHistory == 0;
    this.activeTab = (this.ordersHidden && this.trackingHidden) ? "History" : this.ordersHidden || (this.ordersReadOnly && !this.trackingReadOnly && !this.trackingHidden) ? "Tracking" : "Orders";
    this.tabIndex = (this.ordersHidden && this.trackingHidden) ? 0 : (this.ordersReadOnly && !this.trackingReadOnly && !this.trackingHidden) ? 1 : 0;
    this.readOnly = (this.activeTab == 'Orders' && this.ordersReadOnly) || (this.activeTab == 'Tracking' && this.trackingReadOnly);
    this.showForms = !this.readOnly
    if (!this.ordersHidden){ this.tabs.push("Orders")};
    if (!this.trackingHidden){ this.tabs.push("Tracking")};
    if (!this.historyHidden){ this.tabs.push("History")};
    this.fabUpdateButtonLabel = "Update"; //this.activeTab == "Orders" ? "Complete" : "Update";
    this.madeCheckbox = this.activeTab == "Orders" ? false : true;

    if (this.ordersHidden || this.readOnly) {
      this.quickEdit = false;
      this.eeService.onlyMakeSignFields(this.quickEdit);
    } else {
      this.quickEdit = true;
      this.eeService.onlyMakeSignFields(this.quickEdit);
    }

    // end Visibility / Read Only setup

    this.signLyrId = parseInt(this.authenticationService.currentUserValue.tableIds.signId, 10);
    this.currentUser = this.authenticationService.currentUserValue;
    this.subsUserRoles = this.userService.getRoleslist().subscribe((evt) => {
      this.objGlobals.userRoles = evt;
    });

    this.assetAttributesService.getDomainValues().subscribe((results: any) => {
      let index = results.domains.findIndex(result => result.name == "FabLocation");
      if (index > -1){
        this.LocationList = [];
        results.domains[index].codedValues.forEach(codedVal => {
          this.LocationList.push ({value: codedVal.code, display: codedVal.name});
        });
        this.LocationList.push ({value: null, display: null});
        this.LocationList.push ({value: null, display: null});
      }
    });

    this.subsTasksModified = this.assetDetailService.tasksModified.subscribe((result) => {
      // refresh grid when asset record is updated
      this.queryForTasks();
    });
    this.subsEmitOpenDetailedMaintenance = this.eeService.emitOpenDetailedMaintenance.subscribe((result) => {
      let taskRecs = result.tasks;
        //// UNCOMMENT to test grid behaviour in local debug mode
        ////           grid displays local db data but updates go to server database so, unless its faked, we don't see how grid responds.
        // let selMaintIDs = [];
        // this.gridApiActive.getSelectedRows().forEach((selected) => {
        //   let index = taskRecs.findIndex(taskRec => taskRec.MaintID == selected.MaintID);
        //   if (index > -1){
        //     if(this.activeTab == "Orders"){
        //       taskRecs.splice(index, 1);
        //     }else{
        //       taskRecs[index].Worker = this.fabWorker;
        //       taskRecs[index].FabLocation = this.fabLocation;
        //       taskRecs[index].FabComment = this.fabComment;
        //     }
        //   }
        // })`
      this.gridApiActive.setGridOption("rowData", taskRecs);
      this.showGridDataOnMap();
      this.loading = false;
      this.checkLoadQueue();
    });
  }

  ngOnInit(): void {
    if (this.map.getLayer("sms-tasks-layer")) {
      this.taskGraphicsLyr = this.map.getLayer("sms-tasks-layer");
    } else {
      this.taskGraphicsLyr = new this.genericMapMethodsService.GraphicsLayer({ id: "sms-tasks-layer" });
      this.map.addLayer(this.taskGraphicsLyr);
    }
    this.taskGraphicsLyr.on("click", (evt) => {
      let AssetID;
      if (evt.graphic.attributes.ParentID) {
        AssetID = evt.graphic.attributes.ParentID;
      } else {
        AssetID = evt.graphic.attributes.AssetID;
      }
      if (this.gridApiActive){
        this.gridApiActive?.deselectAll();
        this.gridApiActive.forEachNode( (node) => {
          if (node.data.AssetID === AssetID || node.data.ParentID === AssetID) {
            node.setSelected(true);
            if (node.rowIndex !== null) {
              this.gridApiActive.ensureIndexVisible(node.rowIndex, "middle");
            }
          }
        });
      }

      this.eeService.selectAssetForTaskRecord(evt.graphic.attributes);
    });
    const ftrLyrActivity = new this.FeatureLayer(this.currentUser.webServiceURL + environment.featureServer + this.currentUser.tableIds.activityId, { outFields: ["*"] });
    ftrLyrActivity.on(
      "Load",
      function (evt) {
        this.activityLyrDomains = evt.layer.types;
      }.bind(this)
    );
    this.loading = true;
    this.queryForTasks();
    this.assetDetailService.getAssetIDFormat(this.Query, this.QueryTask, this.FeatureLayer);

    //ADA fix
    //document.getElementById("closeTaskTable").focus();
    //  var alertZ = document.getElementById('ag-20-of-page');
    //  alertZ.innerText ="hello"

    this.userService.getWorkerList(this.currentUser.clientId, [this.signLyrId]).subscribe( 
       (result: any) => {
        this.clientUsersList = result.map((data) => ({ value: data.displayName, display: data.displayName }));
        this.clientUsersList.push({ value: '', display: '' });
        this.clientUsersList.push({ value: '', display: '' });
      },
       (error: any) => {this.clientUsersList = [{ value: this.currentUser.username, display: this.currentUser.displayName }]}
    );

    this.maintenanceLyr = new this.FeatureLayer(this.currentUser.webServiceURL + environment.featureServer + this.currentUser.tableIds.maintenanceId, { outFields: ["*"] });
  }

  initialState = {};
  onGridReady(evt, tab: string){
    switch(tab){
      case "Orders":
        this.gridApiOrders = evt.api;
        if(this.activeTab=="Orders"){ this.gridApiActive = evt.api; }
        this.initialState["Orders"] = evt.api.getColumnState()
        this.restoreGridState(tab, this.gridApiOrders);
        break;
      case "Tracking":
        this.gridApiTracking = evt.api;
        if(this.activeTab=="Tracking"){ this.gridApiActive = evt.api; }
        this.initialState["Tracking"] = evt.api.getColumnState()
        this.restoreGridState(tab, this.gridApiTracking);
        break;
      case "History":
        this.gridApiHistory = evt.api;
        if(this.activeTab=="History"){ this.gridApiActive = evt.api; }
        this.initialState["History"] = evt.api.getColumnState()
        this.restoreGridState(tab, this.gridApiHistory);
        break;
    }

    //this.gridApiActive.sizeColumnsToFit();
    this.addSelCountSpan(tab);
  }

  ngOnDestroy(): void {
    this.map.graphics.clear();
    if (this.taskGraphicsLyr) this.taskGraphicsLyr.clear();
    if (this.gridApiOrders) {
      this.gridApiOrders = null;
    }
    if (this.gridApiTracking) {
      this.gridApiTracking = null;
    }
    if (this.gridApiHistory) {
      this.gridApiHistory = null;
    }
    if (this.gridApiActive) {
      this.gridApiActive = null;
    }
    this.eeService.onlyMakeSignFields(false);
  }

  toggleUpdateForm(): void {
    if (this.showGridManagementForm) {
      this.showGridManagementForm = false;
      this.showDatesForm = (this.activeTab == "History");
      this.showUpdateForm = (this.activeTab != "History");
    }
    else {
      this.allColumns = this.gridApiActive.getAllGridColumns().map( function(c) {
        return {"colId": c.getColId(), "visible": c.isVisible()};
      })
      this.showGridManagementForm = true;
      this.showUpdateForm = false;
      this.showDatesForm = false;
      //this.gridApiActive.sizeColumnsToFit();  //doesn't work
    }
  }

  //#region  grid content

  queryForTasks() {
    const assetIDsList = [];
    const tasksFilter = {};
    this.map.graphics.clear();                    // remove active asset red pin
    this.eeService.setAssetViewer(false);
    this.map.graphicsLayerIds.forEach(            // clear map
      function (id) {
        this.map.getLayer(id).clear();
      }.bind(this)
    );

    try {
      tasksFilter["Activity"] = ["New", "Replace"]
      tasksFilter["Region" + this.currentUser.selectedRegion.regionLevel] = [this.currentUser.selectedRegion.regionName.toString()];
      tasksFilter["AssetName"] = ["Sign"]
      if (this.assignedToMeChecked) {
        tasksFilter["Worker"] = [this.currentUser.username];
      }
      if (this.activeTab == "Orders") {
        tasksFilter["FabStatus"] = 0; //0=Fabricate.  note: when FabStatus=0, stored proc the API calls returns where FabStatus= 0 or is null
      }
      if (this.activeTab == "Tracking") {
        tasksFilter["FabStatus"] = 1; //Fabricated
      }
      if (this.activeTab != "History"){
        // if asset is inactive or task is closed/inactive assume sign was deleted or installed and the fab no longer needs to be tracked.
        // for History we want to see everything that has been fabricated inclusive of all statuses.
        tasksFilter["AssetStatus"] = ["Active"];
        tasksFilter["Status"] = ["Open"];
      }
      if (this.activeTab == "History"){
        tasksFilter["FabDateFrom"] = this.startDate;
        tasksFilter["FabDateTo"] = this.endDate;
      }
      this.eeService.getUpdatedDetailedMaintenance(tasksFilter, "Open"); //  'open' param doesn't mean anything here, determines which emit is done when complete.
    } catch (error) {
      console.error(error);
    }
  }

  onGridFilterChanged(evt): void{
    if (evt.source == "columnFilter") {  //user changed filter
      evt.api.deselectAll();
      this.showGridDataOnMap();
      this.saveGridState();
    }
  }

  onGridColumnMoved(evt): void {
    if(evt.finished && evt.toIndex >= 0){ //toIndex set when user drags column, not during inital grid layout
      this.saveGridState();    
    }
  }
  onGridColumnResized(evt): void {
    if(evt.source === 'uiColumnResized' && evt.finished) {
      this.saveGridState();
    }
  }

  colVisibilityClicked(colId:string, event){
    const checkbox = event.target as HTMLInputElement;
    this.gridApiActive.setColumnsVisible([colId], checkbox.checked);
    //this.gridApiActive.sizeColumnsToFit();  //doesn't work well if requires setting col width less than minimum
    this.saveGridState();
  }

  assignedToChanged(event) {
    try {
      this.gridApiActive.deselectAll();
      this.assignedToMeChecked = event.checked;
      if (this.loading){
        this.changeWhileLoading_assignedToEvent = event;
      }
      else
      {
        this.loading = true;
        this.queryForTasks();
      }
    } catch (error) {
      console.error(error);
    }
  }

  tabChanged(event) {
    this.activeTab = this.tabs[event.index];
    this.showUpdateForm = true;
    this.showDatesForm = false;
    this.showGridManagementForm = false;
    this.fabComment = this.fabWorker = this.fabLocation = "";
    switch (this.activeTab){
      case "Orders":
        this.fabUpdateButtonLabel = "Update"; //"Complete";
        this.gridApiActive = this.gridApiOrders;
        this.madeCheckbox = false;
        if (this.quickEdit) {this.eeService.onlyMakeSignFields(this.quickEdit);}
        break;
      case "Tracking":
        this.fabUpdateButtonLabel = "Update";
        this.gridApiActive = this.gridApiTracking;
        this.madeCheckbox = true;
        if (this.quickEdit) {this.eeService.onlyMakeSignFields(false);}
        break;
      case "History":
        this.gridApiActive = this.gridApiHistory;
        this.showDatesForm = true;
        this.showUpdateForm = false;
        if (this.quickEdit) {this.eeService.onlyMakeSignFields(false);}
        break;
    }
    //this.gridApiActive.sizeColumnsToFit();
    this.gridApiActive.deselectAll();
    this.readOnly = (this.activeTab == 'Orders' && this.ordersReadOnly) || (this.activeTab == 'Tracking' && this.trackingReadOnly);
    this.showForms = !this.readOnly
    if (this.loading){
      this.changeWhileLoading_tabEvent = event; // TSDRSAM-3109. defer tabChange until current load completed.
    }
    else {
      try {
        this.loading = true;
        this.addSelCountSpan(this.activeTab);
        this.queryForTasks();
      } catch (error) {
        console.error(error);
      }
    }
  }

  checkLoadQueue(){  //added for TSDRSAM-3109
    if (this.changeWhileLoading_tabEvent !== null){
      this.tabChanged(this.changeWhileLoading_tabEvent);
    }
    else if (this.changeWhileLoading_assignedToEvent !== null){
      this.assignedToChanged(this.changeWhileLoading_assignedToEvent);
    }
    this.changeWhileLoading_tabEvent = null;
    this.changeWhileLoading_assignedToEvent = null;
  }
  //#endregion  grid content



  //#region map and asset viewer coordination wtih grid

  showGridDataOnMap(): void {
    try {
      this.map.graphics.clear(); // remove active asset red pin
      this.eeService.setAssetViewer(false);  
      if (this.taskGraphicsLyr) this.taskGraphicsLyr.clear();
      let listOfTasks = [];
      this.gridApiActive.forEachNodeAfterFilterAndSort(function(rowNode, index){
          listOfTasks.push(rowNode.data);
      });
      for (let i = 0; i < listOfTasks.length; i++) {
          let imageUrl = "";
          if (listOfTasks[i].Status === "Closed") {
            imageUrl = "assets/images/marker_blue.png";
          } else {
            imageUrl = "assets/images/marker_orange.png";
          }
          const width = 20;
          const height = 23;
          let point;
          if (listOfTasks[i].Shape.slice(0, listOfTasks[i].Shape.indexOf(" ")) == "POINT") {
            point = new this.Point(
              parseFloat(listOfTasks[i].Shape.slice(listOfTasks[i].Shape.indexOf("(") + 1, listOfTasks[i].Shape.split(" ", 2).join(" ").length)),
              parseFloat(listOfTasks[i].Shape.slice(listOfTasks[i].Shape.split(" ", 2).join(" ").length, listOfTasks[i].Shape.indexOf(")"))),
              this.map.spatialReference
            );
          }
          const graphic = new this.Graphic(point, new this.PictureMarkerSymbol(imageUrl, width, height).setOffset(0, 5));
          graphic.setAttributes(listOfTasks[i]);
          graphic.setSymbol(new this.PictureMarkerSymbol(imageUrl, width, height).setOffset(0, 5));
          this.taskGraphicsLyr.add(graphic);
      }
    } catch (error) {
      console.error(error);
    }
  }

  openAssetViewerForSelected(lastSelectedRow, allSelectedRows) {  
    this.map.graphics.clear();
    this.eeService.setAssetViewer(false);
    if(allSelectedRows.length == 1 ){  // only show asset viewer when a single row is selected
      try {
        let AssetID = (lastSelectedRow.ParentID) ? lastSelectedRow.ParentID : lastSelectedRow.AssetID;
        if (lastSelectedRow.GeomWKT) {
          const imageUrl = "assets/images/marker_orange.png";
          const width = 20;
          const height = 20;
          const graphic = new this.Graphic(new this.Point(JSON.parse(lastSelectedRow.GeomWKT)), new this.PictureMarkerSymbol(imageUrl, width, height).setOffset(0, 5));
          graphic.setSymbol(new this.PictureMarkerSymbol(imageUrl, width, height).setOffset(0, 5));
          graphic.setAttributes(lastSelectedRow);
          let shiftedGeom = graphic.geometry;  // attempt to keep the selected point in visible portion of map when table is open, so a little left and up from center
          shiftedGeom.x += shiftedGeom.spatialReference.wkid == 4326 ? .015 : 2000;
          shiftedGeom.y -= shiftedGeom.spatialReference.wkid == 4326 ? .02 : 2000;
          this.map.centerAndZoom(shiftedGeom, 13);
        }
        this.eeService.selectAssetForTaskRecord(allSelectedRows[0]);
      } catch (error) {
        console.error(error);
      }
    }
  }
  //#endregion map and asset viewer coordination wtih grid

  closeSmartTable() {
    try {
      this.closeTable.emit(true);
      if (this.taskGraphicsLyr) this.taskGraphicsLyr.clear();
      this.eeService.clearActiveAssetVariables();
      // For ADA story - by Subba
      let mainPageTools = document.querySelectorAll('[data-mainPageTabbing="yes"]');
      if (mainPageTools.length > 0) {
        mainPageTools.forEach((element) => {
          element.setAttribute("tabindex", "0");
        });
      }
      let bMapTools = document.querySelectorAll('[data-BMapTabbing="yes"]');
      if (bMapTools.length > 0) {
        bMapTools.forEach((element) => {
          element.setAttribute("tabindex", "0");
        });
      }
    } catch (error) {
      console.error(error);
    }
  }


  //#region row selection and update

  onGridSelectionChanged(evt): void {
    let latestSelectedRow;
    let selectedRows = evt.api.getSelectedRows();
    this.lastUpdate = '';
    if (selectedRows.length > this.previousSelectedRows.length){
      latestSelectedRow = selectedRows.filter(selRow => !this.previousSelectedRows.some(prevSelRow => selRow.MaintID === prevSelRow.MaintID))[0];
    } else {
      //no meaningful order to remaining, take first
      latestSelectedRow = selectedRows[0];
    }
    if (selectedRows.length == 1){
      this.fabWorker = latestSelectedRow.Worker;
      this.fabLocation = latestSelectedRow.FabLocation;
      this.fabComment = latestSelectedRow.FabComment;
    } else {
      this.fabWorker = "";
      this.fabLocation = "";
      this.fabComment = "";
    }
    this.previousSelectedRows = selectedRows;
    this.openAssetViewerForSelected(latestSelectedRow, selectedRows);
    document.getElementById("selCount"+this.activeTab).textContent = "["+selectedRows.length+"]";
    this.madeCheckbox = this.madeCheckbox = this.activeTab == "Orders" ? false : true;
  }

  madeClicked(event){
    this.madeCheckbox = !this.madeCheckbox;
  }

  setWorker(event)
  {
    this.fabWorker = event;
  }
  setLocation(event)
  {
    this.fabLocation = event;
  }
  updateHistoryRange(){
    if (this.lastUpdate != this.startDate.toLocaleDateString("en-US") + this.endDate.toLocaleDateString("en-US")){
      this.queryForTasks();
      this.lastUpdate = this.startDate.toLocaleDateString("en-US") + this.endDate.toLocaleDateString("en-US")
    }
  }

  updateClicked(event){
    if (this.activeTab == "Tracking" && !this.madeCheckbox){
      Swal.fire({title: "Move selected back to Orders?", showCancelButton: true}).then((result) => { 
        if (result.dismiss){
          this.madeCheckbox = true;
          return;
        } 
        else {
          this.updateSelectedTasks(event);
        }
      });
    }
    else {
      this.updateSelectedTasks(event);
    }
  }

  updateSelectedTasks(event)
  {
    let taskAttributes;
    let objectID;
    let maintIDs = [];
    let newAttributes = [];
    let worker = this.fabWorker;
    let loc = this.fabLocation;
    let comm = this.fabComment;
    let made = this.madeCheckbox;

    if(this.readOnly || this.lastUpdate == worker+loc+comm+made ){
      return;
    }

    try{
      this.gridApiActive.getSelectedRows().forEach((selectedRow) => {
        maintIDs.push("'" + selectedRow.MaintID + "'");
      });
      this.getFilteredFeaturesByFieldSubscribe = this.genericLayerService
        .getFilteredFeaturesByListOfValues(this.currentUser.tableIds.maintenanceId, "MaintID", maintIDs.toString())
        .subscribe((result: any) => {
          let featuresArray = [];

          result.features.forEach((rec) => {
            taskAttributes = rec.attributes;

            //// update fields including removing any previous value of no value given
            taskAttributes.FabComment = comm == null ? null : comm;
            taskAttributes.FabLocation = loc == null ? null : loc;
            taskAttributes.Worker = worker == null ? null : worker;
            
            ////  update fields only if value given
            // if (comm){ taskAttributes.FabComment = comm; }
            // if (loc){ taskAttributes.FabLocation = loc; }
            // if (worker){ taskAttributes.Worker = worker; }
            if(this.activeTab == "Orders" && made)
            {
              taskAttributes.FabStatus = 1; //fabricated
              taskAttributes.FabBy = this.currentUser.username;
              taskAttributes.FabDate = new Date(Date.now()).getTime();
            }
            if (this.activeTab == "Tracking" && !made){
              taskAttributes.FabStatus = 0; //not fabricated
              taskAttributes.FabBy = null;
              taskAttributes.FabDate = null;
            }
            taskAttributes.LastModifyDate =  new Date(Date.now()).getTime();
            taskAttributes.ModifiedBy = this.currentUser.username;
            const features = new this.Graphic();
            features.setAttributes(taskAttributes);
            featuresArray.push(features);
          });

          this.maintenanceLyr.applyEdits(null, featuresArray, null)
            .then(
              function (result) {
                this.lastUpdate = worker+loc+comm; 
                let msg = maintIDs.length + " updated";
                Swal.fire({text:msg, toast:true, timer:2000, showConfirmButton:false, customClass: 'colored-toast', position:"bottom-right"});
                this.queryForTasks();
              }.bind(this)
          );
      });
    }
    catch (error)
    {
      console.log(error);
    }
  }

  addSelCountSpan(tab: string){
    // show count of selected rows in pagination panel
    const gridId = 'grid' + tab;
    const selCountDisplay = document.createElement('span');
    selCountDisplay.id = "selCount" + tab;
    selCountDisplay.style.marginLeft = '1rem';
    selCountDisplay.style.minWidth = '20px';
    const t = document.getElementById(gridId);
    if (t){
      const pp = t.querySelector('.ag-paging-panel')
      if(!this.gridSelCountAdded.includes(tab) ) {
        pp.appendChild(selCountDisplay);
        this.gridSelCountAdded.push(tab);
      }
    }
  }
  //#endregion  row selection and update

  
  exportData(){
    //12/6/25 csv only but pdf code works if want to add
    let format="CSV";
    let colDefs;
    let grid;
    let rawData = [];
    let presentedData = [];

    grid = this.gridApiActive;

    // collect colIds in current visible column order
    let visibleOrderedColIds = this.gridApiActive.getColumnState()
      .filter ( c => { if (c.hide == false) {return c}})
      .map ( c => { return c.colId });

    // collect colDefs in current visible column order
    let visibleOrderedHeaders = [];
    let visibleOrderedColDefs = [];
    colDefs = this["columnDefs"+this.activeTab];
    visibleOrderedColIds.forEach( colId => {
      let colDef = colDefs.find( def => def && def.colId === colId);
      visibleOrderedHeaders.push (colDef.headerName);
      visibleOrderedColDefs.push (colDef);
    });

    // collect raw data - currently selected grid rows or all
    rawData = grid.getSelectedRows();
    if (rawData.length == 0) {
      grid.forEachNodeAfterFilterAndSort(function(rowNode, index){
        rawData.push(rowNode.data);
      });
    }

    //get row data as presented in grid (with column visibility, order and concatenated data)
    rawData.forEach(function(task){
      let rowObj = {};
      visibleOrderedColDefs.forEach( colDef => {
        if (colDef.field) {
          rowObj[colDef.headerName] = task[colDef.field];
        }
        else if (colDef.valueGetter){
          rowObj[colDef.headerName] = colDef.valueGetter({data:task, colDef:colDef})
        }
        else {
          //selection checkbox?
        }
      });
      presentedData.push(rowObj);
    })

    if (presentedData == null || !presentedData.length) {
      return null;
    }

    let csv;
    const tablebody = [];
    const tableheader = [];
    const columnDelimiter = ",";
    const lineDelimiter = "\n";

    tablebody.push(tableheader);
        let result = "";
        let columnLength = visibleOrderedColDefs.length;
        if (format === "PDF") {
          columnLength = 15
        }

        // csv column headers
        visibleOrderedColDefs.forEach((colDef, i) => {
          if (i < columnLength) {
            tableheader.push({ text: colDef.headerName, style: "tableHeader" });   // e.g. [{text: 'Asset ID', style: 'tableheader'}, etc.]
          }
        });
        tablebody.push(tableheader);
        result += tableheader.map(x=>x.text).join(columnDelimiter);   // e.g. "Asset ID,Asset Code,Activity, etc"
        result += lineDelimiter;
        let ctr = 0;

        // csv rows
        presentedData.forEach((row) => {
          const tablerow = [];
          visibleOrderedColDefs.forEach(function (colDef, i) {
            if (i < columnLength) {
              let cellValue = row[colDef.headerName] == undefined ? "" : row[colDef.headerName];
              tablerow.push(cellValue);        // e.g. ["SIG_66868", "G20-1", "New", etc.]
              result += cellValue;
              result += columnDelimiter;     // comma delimited with column heads in first row and data rows after
            }
          });
          ctr++;
          tablebody.push(tablerow);    // array of comma del rows (column heads first)
          result += lineDelimiter;
        });

        // get date time to to append to file name for uniqueness
        const currentdatetime = new Date();
        const padTo2Digits = (num) => num.toString().padStart(2, '0');
        const formatteddate = "_" +
          padTo2Digits((currentdatetime.getMonth() + 1)) +
          padTo2Digits(currentdatetime.getDate()) +
          currentdatetime.getFullYear().toString() + 
          "_" + ( currentdatetime.getHours() > 12 ? padTo2Digits(currentdatetime.getHours()-12 ) : padTo2Digits(currentdatetime.getHours()) ) +
          padTo2Digits(currentdatetime.getMinutes()) +
          padTo2Digits(currentdatetime.getSeconds());


        if (ctr === presentedData.length && format === "CSV") {
          csv = result;                             // csv just needs the comma sep file

          if (!csv.match(/^data:text\/csv/i)) {
            csv = "data:text/csv;charset=utf-8," + csv;
          }

          const encodedUri = encodeURI(csv);
          const link = document.createElement("a");
          link.setAttribute("href", encodedUri);
          const filename = this.activeTab + formatteddate + ".csv";
          link.setAttribute("download", filename);
          link.click();
        }

        if (ctr === presentedData.length && format === "PDF") {
          const dd = {
            pageSize: "A4",
            pageOrientation: "landscape",
            fontSize: 8,
            widths: "auto",
            content: [
              {
                style: "tableExample",
                table: {
                  body: tablebody
                },
                pageOrientation: "portrait",
                layout: {
                  fillColor(rowIndex, node, columnIndex) {
                    return rowIndex % 2 === 0 ? "#F5F5F5" : null;
                  }
                }
              }
            ],
            styles: {
              header: {
                fontSize: 9,
                bold: true,
                margin: [0, 0, 0, 10]
              },
              subheader: {
                fontSize: 8,
                bold: true,
                margin: [0, 10, 0, 5]
              },
              tableExample: {
                margin: [0, 5, 0, 15],
                fontSize: 8
              },
              tableHeader: {
                bold: true,
                fontSize: 9,
                color: "black"
              }
            }
          };
          pdfMake.createPdf(dd).download(
            this.activeTab + formatteddate + ".pdf"
          );
        }
  }

  saveGridState(){
    const makeState = {
      Orders: {
        column: this.gridApiOrders.getColumnState(),
        filter: this.gridApiOrders.getFilterModel()
      },
      Tracking: {
        column: this.gridApiTracking.getColumnState(),
        filter: this.gridApiTracking.getFilterModel()
      },
      History: {
        column: this.gridApiHistory.getColumnState(),
        filter: this.gridApiHistory.getFilterModel()
      }
    }
    localStorage.setItem(this.currentUser.username + "_makeState", JSON.stringify(makeState));
  }

  restoreGridState(tab, gridApi){
    var storedState = JSON.parse(localStorage.getItem(this.currentUser.username + "_makeState"));
    if(storedState && storedState[tab]){
      if(storedState[tab].column && storedState[tab].column != "undefined") {
        gridApi.applyColumnState({state: storedState[tab].column, applyOrder: true});
      }
      if(storedState[tab].filter){
        gridApi.setFilterModel(storedState[tab].filter);
      }
    } 
  }

  resetGridState(){
    this.gridApiActive.applyColumnState({state: this.initialState[this.activeTab], applyOrder: true})
    this.allColumns = this.gridApiActive.getAllGridColumns().map( function(c) {
      return {"colId": c.getColId(), "visible": c.isVisible()};
    })
    this.gridApiActive.sizeColumnsToFit();
    this.clearFilters();
    this.saveGridState();
  }
  clearFilters(){
    this.gridApiActive.setFilterModel(null);
    this.gridApiActive.onFilterChanged();
  }

  quickEdit;
  toggleQuickEdit(){
    this.quickEdit = !this.quickEdit;
    this.eeService.onlyMakeSignFields(this.quickEdit);
  }
}
